import ActionType from './ActionType';
import axios from 'axios';



const createBussinessListAction=(bussinessListJson)=>{
    return {
        type:ActionType.FETCH_BUSSINESS_LIST,
        data:bussinessListJson.list
    }
}

const createBussinessConDataAction=(bussinessConJson)=>{
    return {
        type:ActionType.FETCH_BUSSINESS_CON,
        data:bussinessConJson.list,
    }
}

const createBussinessArticleAction=(bussinessArticleJson)=>{
    return {
        type:ActionType.FETCH_BUSSINESS_ARTICLE,
        data:bussinessArticleJson,
    }
}

export const fetch_bussinessList=(method,params)=>{
    return (dispatch)=>{
        axios({
            url:'/api/BusinessCate',
            method:method,
            params:params,
            headers:{
                'Content-Type':'application/json;charset=utf-8',
            }
        }).then((response)=>{
            dispatch(createBussinessListAction(response.data.data))
        }).catch((error)=>{
            console.log(error)
        })
    }
}

export const fetch_bussinessConData=(method,params)=>{
    return (dispatch)=>{
        axios({
            url:'/api/Business',
            method:method,
            params:params,
            headers:{
                'Content-Type':'application/json;charset=utf-8',
                // 'Access-Control-Allow-Headers':'Content-Type, Content-Length, Authorization, Accept, X-Requested-With , yourHeaderFeild, Access-Control-Allow-Origin',
                // 'Access-Control-Allow-Origin':'api.apiopen.top',
                // 'X-Powered-By':'3.2.1',
                // "Access-Control-Allow-Methods":"PUT,POST,GET,DELETE,OPTIONS",
            }
        }).then((response)=>{
            dispatch(createBussinessConDataAction(response.data.data))
        }).catch((error)=>{
            console.log(error)
        })
    }
}

// 获取文章内容
export const fetch_bussiness_article=(method,params)=>{
    return (dispatch)=>{
        axios({
            url:'/api/Business',
            method:method,
            params:params,
            headers:{
                'Content-Type':'application/json;charset=utf8',
            }
        }).then((response)=>{
            dispatch(createBussinessArticleAction(response.data.data))
        }).catch((error)=>{
            console.log(error)
        })
    }
}